import { render } from "./TitleAndList.vue?vue&type=template&id=68304c8b&ts=true"
import script from "./TitleAndList.vue?vue&type=script&lang=ts"
export * from "./TitleAndList.vue?vue&type=script&lang=ts"

import "./TitleAndList.vue?vue&type=style&index=0&id=68304c8b&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__